module.exports = __webpack_public_path__ + "static/media/high-tension-dark.a3cbe558.png";